import { render } from "./DropdownRouterLink.vue?vue&type=template&id=146ca766"
import script from "./DropdownRouterLink.vue?vue&type=script&lang=js"
export * from "./DropdownRouterLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__